import IntegrationCard from "./IntegrationCard";
import type { Integration } from "../types";
import { transformToCardData } from "../utils";

// Props interface
interface IntegrationsListProps {
  integrations: Integration[];
  onManage: (integrationName: string) => void;
}

// Main list component
function IntegrationsList({ 
  integrations, 
  onManage 
}: IntegrationsListProps) {
  if (integrations.length === 0) {
    return (
      <div className="flex items-center justify-center py-12 text-muted-foreground">
        No integrations available.
      </div>
    );
  }

  return (
    <div className="grid w-full grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 items-stretch">
      {integrations.map((integration) => {
        const cardData = transformToCardData(integration);
        
        return (
          <IntegrationCard
            key={integration.id}
            integration={cardData}
            onManage={onManage}
            integrationDetails={integration}
          />
        );
      })}
    </div>
  );
}

export default IntegrationsList;
